// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const ExtractionStatusOut = zod.object({
  "error": zod.union([zod.string(),zod.null()]),
  "id": zod.uuid(),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed'])
});

export type ExtractionStatusOut = zod.input<typeof ExtractionStatusOut>;
export type ExtractionStatusOutOutput = zod.output<typeof ExtractionStatusOut>;
